import type { FacilityWorkflowRunFocusStepPayload } from '@Application/WorkflowRuns/FacilityWorkflowRuns/Actions/facilityWorkflowRunsFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The step that explains a run's state: `isStalled` is a server decision, never recomputed here.
 */
class WorkflowRunFocusStepView {
	readonly id: number;
	readonly position: number;
	readonly label: string;
	readonly status: LabeledValueView;
	readonly isStalled: boolean;

	constructor(payload: FacilityWorkflowRunFocusStepPayload) {
		this.id = payload.id;
		this.position = payload.position;
		this.label = payload.label;
		this.status = new LabeledValueView(payload.status);
		this.isStalled = payload.isStalled;

		Object.freeze(this);
	}
}

export default WorkflowRunFocusStepView;
